import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";
import Select from "react-select"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { useDispatch } from "react-redux";
import Loader from "components/Loader/Loader";
import { deleteCourse, fetchAllCourses } from "helpers/course_helper";
import { toast } from "react-toastify";
import { DOWNLOAD_COURSE_DETAILS_FILE, FETCH_IMAGE } from "helpers/url_helper";
import { useNavigate } from "react-router-dom";
import { generatePresignedUrlForAccess } from "helpers/Content_helper";
import axios from "axios";
import ScormPackageList from "./components/ScormPackageList";

const AllScormCourses = (props) => {
    document.title = "Question Bank | All Courses";

    const [loader, setLoader] = useState(false);
    const [allCourses, setAllCourses] = useState([]);
    const navigate = useNavigate();


    const breadcrumbItems = [
        { title: "Course", link: "#" },
        { title: "All Courses", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('All Courses', breadcrumbItems)
    })

    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])




    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between mb-3">
                                <CardTitle className="h4">All Courses </CardTitle>

                            </div>

                            <ScormPackageList />
                        </CardBody>
                    </Card>
                </Col>
            </Row>






        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(AllScormCourses);